import { useGet } from "@onefront/react-sdk";
import { UtilityWs } from "../../../@types/enums/utilities/UtilityWs";

interface UtilitiesGetParamsFetch {
    params?: any;
    headers?: any;
}

interface UseGetUtilitiessData {
    (utilityName: keyof typeof UtilityWs, params?: any | object, lazy?: boolean): {
        data?: Array<any>;
        loading?: boolean;
        fetch: (fetchConfig?: UtilitiesGetParamsFetch) => Promise<any>;
        error: boolean;
        lazy?: boolean;
    };
}

export const useGetUtilities: UseGetUtilitiessData = (utilityName, params = {}, lazy = false) => {
    return useGet(`rnd:core:workspace-read:api://v1/utilities/${utilityName}`, {
        params: {
            ...params
        },
        lazy
    });
};
